import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { hideNavUserAction } from "../store/actions/showNavUserAction";
import Footer from "./Footer";

function UserOrder() {
  const [userOrders, setUserOrders] = useState([]);
  const userId = useSelector((state) => state.user_auth.id);
  const user = useSelector((state) => state.user_auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const initOrder = async () => {
      const { data } = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + "/orders/" + userId,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      /* const { data } = await axios.get(process.env.REACT_APP_API_URL + "/orders/" + userId); */
      setUserOrders(data);
    };
    initOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.scrollTo(0, 0);
    dispatch(hideNavUserAction());
  }, []);

  return (
    <div>
      <div className="container shopping_list">
        <div className="row">
          <div className="col-lg-12 mb-5">
            <h4>Mis compras</h4>
          </div>
          <Table>
            <thead>
              <tr>
                <th>Fecha de Compra</th>
                <th>Productos</th>
                <th>Cantidad</th>
                <th>Dirección de Entrega</th>
              </tr>
            </thead>
            <tbody>
              {userOrders.length === 0 ? (
                <tr>
                  {" "}
                  <td colSpan="3">No se ha hecho ningún pedido todavía.</td>
                </tr>
              ) : (
                userOrders.map((e) => (
                  <tr key={e}>
                    <td>
                      {new Date(e.createdAt).toLocaleString("es", {
                        dateStyle: "medium",
                      })}
                    </td>
                    <td>
                      {e.products.map((p) => (
                        <Link
                          className="d-block text-black"
                          to={"/producto/" + p.slug}
                        >
                          {p.name}
                        </Link>
                        
                      ))}
                    </td>
                    <td>
                      {e.products.map((q) => (
                        <div>{q.quantity}</div>
                      ))}
                    </td>

                    <td>{e.address}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default UserOrder;
